<header class="nav-wrapper">
  <!-- LEFT: LOGO -->
  <div class="nav-left">
    <a routerLink="/" class="brand">
      <div class="logo-row">
        <img class="logo-text" src="assets/logo-text.png" alt="alugul">
        <div class="logo-icon-wrap">
          <span class="puff p1"></span>
          <span class="puff p2"></span>
          <span class="puff p3"></span>
          <span class="puff p4"></span>
          <img class="logo-icon" src="assets/logo-icon.png" alt="">
          <div class="tracks">
            <span class="track"></span><span class="track"></span><span class="track"></span>
            <span class="track"></span><span class="track"></span><span class="track"></span>
          </div>
        </div>
      </div>
    </a>
  </div>

  <!-- ========================== -->
  <!-- CENTER: 3 CONDITION LOGIC -->
  <!-- ========================== -->

  <!-- 1️⃣ ICON NAVBAR -->
  <!-- <div class="nav-center" *ngIf="isIconNavbar">
    <div class="nav-item" routerLink="/" [ngClass]="{ active: activeNav === '/' }">
      <img src="../../../../assets/landingpage/Vehicles-icon.svg" class="nav-icon" />
      <span>Rent<br />Vehicles/Equipment</span>
      <div class="underline"></div>
    </div>

    <div class="nav-item" routerLink="/booking-garage" [ngClass]="{ active: activeNav === '/booking-garage' }">
      <img src="../../../../assets/landingpage/Garages-icon.svg" class="nav-icon" />
      <span>Book<br />Garages</span>
      <div class="underline"></div>
    </div>

    <div class="nav-item" routerLink="/other-services" [ngClass]="{ active: activeNav === '/other-services' }">
      <img src="../../../../assets/landingpage/Other-services-icon.svg" class="nav-icon" />
      <span>Other<br />Services</span>
      <div class="underline"></div>
    </div>
  </div> -->

  <!-- 2️⃣ SEARCH BAR NAVBAR -->
  <div class="nav-center search-center" *ngIf="isSearchNavbar">
    <app-search-bar mode="navbar"></app-search-bar>
  </div>

  <!-- 3️⃣ EMPTY NAVBAR CENTER -->
  <div class="nav-center empty-center" *ngIf="!isIconNavbar && !isSearchNavbar"></div>

  <!-- RIGHT: ACTION BUTTONS -->
  <div class="nav-right">
    <!-- Not Logged In -->
    <ng-container *ngIf="!currentuid">
      <!-- REGISTER AS VENDOR BUTTON -->
      <button *ngIf="!isFormPage" class="switch-role-nav-btn" (click)="openServiceOfferDialog()">
        Register as Vendor
      </button>

      <!-- CART BUTTON -->
      <!-- CART BUTTON -->
      <button class="round-btn white-btn relative-btn" (click)="toggleCartDropdown($event)">
        <span class="material-icons" style="color: #61c8f8">shopping_cart</span>
        <span class="badge" *ngIf="cartCount$ | async as count">{{
          count
          }}</span>
      </button>

      <!-- DROPDOWN -->
      <div class="cart-dropdown" *ngIf="cartDropdownOpen" (click)="$event.stopPropagation()"
        (mouseenter)="onCartMouseEnter()" (mouseleave)="onCartMouseLeave()">
        <div class="cart-header">
          <h3>Shopping Cart</h3>
        </div>

        <div class="cart-list" *ngIf="cartService.cartItems$ | async as items">
          <div class="cart-item" *ngFor="let item of items" (click)="goToCart()">
            <div class="item-img">
              <img [src]="
                  item.equipmentData?.images?.[0] ||
                  'assets/default-equipment.jpg'
                " alt="Equip" />
            </div>
            <div class="item-info">
              <h4>{{ item.equipmentData?.name }}</h4>
              <p class="rate">AED {{ item.rate }} / {{ item.priceType }}</p>
              <div class="dates">
                {{ item.startDate | date: "dd MMM" }} -
                {{ item.endDate | date: "dd MMM" }}
              </div>
            </div>
          </div>

          <div class="empty-state" *ngIf="items.length === 0">
            <p>Your cart is empty</p>
          </div>
        </div>

        <div class="cart-footer" (click)="goToCart()">
          <span>View All</span>
        </div>
      </div>

      <!-- <button class="round-btn white-btn">
        <img src="../../../../assets/landingpage/globe.png" />
      </button> -->

      <div class="profile-menu-wrapper" (click)="toggleMenu($event)">
        <button class="round-btn blue-btn combined-btn">
          <img src="../../../../assets/landingpage/menu.png" class="menu-icon" />
          <img src="../../../../assets/landingpage/Avatar.png" class="user-icon" />
        </button>

        <!-- CUSTOM DROPDOWN -->
        <div class="custom-dropdown" *ngIf="menuOpen">
          <div class="dropdown-section no-padding">
            <div class="dropdown-item main-link" (click)="Login()">Login</div>
            <div class="dropdown-item main-link" (click)="SignUp()">Signup</div>
          </div>

          <div class="dropdown-divider thin"></div>

          <div class="dropdown-section no-padding">
            <div class="dropdown-item vendor-promo" (click)="openServiceOfferDialog()">
              <div class="promo-content">
                <span class="promo-title">Register as Vendor</span>
                <span class="promo-subtext">Manage bookings, services, and documents—all in one place.</span>
              </div>
              <!-- Optional: Add a small icon/image here if available similar to Myntra style -->
            </div>
          </div>

          <div class="dropdown-divider thin"></div>

          <div class="dropdown-section no-padding">
            <div class="dropdown-item main-link" (click)="goToFAQ()">FAQ</div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Logged In -->
    <ng-container *ngIf="currentuid">
      <!-- REGISTER AS VENDOR BUTTON (Individual Customers only) -->
      <button *ngIf="isVisiting && !isFormPage" class="switch-role-nav-btn" (click)="openServiceOfferDialog()">
        Register as Vendor
      </button>

      <!-- MY BOOKINGS BUTTON (Business Customers only) -->
      <button *ngIf="isCustomer" class="switch-role-nav-btn" (click)="goToBookings()">
        My Bookings
      </button>

      <!-- VENDOR DASHBOARD BUTTON (Real Vendors only) -->
      <button *ngIf="isRealVendor" class="switch-role-nav-btn" (click)="goToVendorDashboard('real')">
        Vendor Dashboard
      </button>

      <!-- CART BUTTON -->
      <!-- CART BUTTON -->
      <button class="round-btn white-btn relative-btn" (click)="toggleCartDropdown($event)">
        <span class="material-icons" style="color: #61c8f8">shopping_cart</span>
        <span class="badge" *ngIf="cartCount$ | async as count">{{
          count
          }}</span>
      </button>



      <!-- DROPDOWN -->
      <div class="cart-dropdown" *ngIf="cartDropdownOpen" (click)="$event.stopPropagation()"
        (mouseenter)="onCartMouseEnter()" (mouseleave)="onCartMouseLeave()">
        <div class="cart-header">
          <h3>Shopping Cart</h3>
        </div>

        <div class="cart-list" *ngIf="cartService.cartItems$ | async as items">
          <div class="cart-item" *ngFor="let item of items" (click)="goToCart()">
            <div class="item-img">
              <img [src]="
                  item.equipmentData?.images?.[0] ||
                  'assets/default-equipment.jpg'
                " alt="Equip" />
            </div>
            <div class="item-info">
              <h4>{{ item.equipmentData?.name }}</h4>
              <p class="rate">AED {{ item.rate }} / {{ item.priceType }}</p>
              <div class="dates">
                {{ item.startDate | date: "dd MMM" }} -
                {{ item.endDate | date: "dd MMM" }}
              </div>
            </div>
          </div>

          <div class="empty-state" *ngIf="items.length === 0">
            <p>Your cart is empty</p>
          </div>
        </div>

        <div class="cart-footer" (click)="goToCart()">
          <span>View All</span>
        </div>
      </div>

      <button class="round-btn white-btn relative-btn" (click)="toggleNotification($event)">
        <span class="material-icons" style="color: #61c8f8">notifications</span>
        <span class="badge" *ngIf="unreadNotificationCount$ | async as count">{{
          count
          }}</span>
      </button>

      <!-- NOTIFICATION DROPDOWN -->
      <div class="notification-dropdown" *ngIf="notificationOpen" (click)="$event.stopPropagation()">
        <div class="notification-header">
          <h3>Notifications</h3>
        </div>
        <div class="notification-list">
          <div class="notification-item" *ngFor="let note of notifications$ | async" [class.unread]="!note.isRead"
            (click)="handleNotificationClick(note)">
            <div class="note-icon">
              <span class="material-icons" [ngClass]="note.type">info</span>
            </div>
            <div class="note-content">
              <h4>{{ note.title }}</h4>
              <p>{{ note.message }}</p>
              <span class="note-time">{{
                note.createdAt?.toDate() | date: "short"
                }}</span>
            </div>
          </div>
          <div class="empty-state" *ngIf="(notifications$ | async)?.length === 0">
            <p>No notifications yet</p>
          </div>
        </div>
        <div class="notification-footer">
          <span (click)="viewAllNotifications()">View All</span>
          <span class="clear-all" (click)="clearAllNotifications()">Clear All</span>
        </div>
      </div>

      <!-- <button class="round-btn white-btn">
        <img src="../../../../assets/landingpage/globe.png" />
      </button> -->

      <div class="profile-menu-wrapper" (click)="toggleLoggedMenu($event)">
        <button class="round-btn blue-btn combined-btn">
          <img src="../../../../assets/landingpage/menu.png" class="menu-icon" />
          <div class="avatar-circle">
            <img *ngIf="currentuserImage" [src]="currentuserImage" alt="Avatar" style="
                width: 100%;
                height: 100%;
                border-radius: 50%;
                object-fit: cover;
              " (error)="currentuserImage = null" />
            <span *ngIf="!currentuserImage">
              {{ currentusername?.charAt(0) | uppercase }}
            </span>
          </div>
          <!-- <img
            src="../../../../assets/landingpage/Avatar.png"
            class="user-icon"
          /> -->
        </button>

        <div class="custom-dropdown" *ngIf="loggedMenuOpen">
          <div class="dropdown-section no-padding">
            <div *ngIf="isRealVendor" class="dropdown-item main-link" (click)="goToVendorDashboard('real')">
              Go to Vendor Page
            </div>

            <div *ngIf="isBusinessUser" class="dropdown-item main-link" (click)="goToVendorDashboard('dummy')">
              Go to Vendor Page
            </div>

            <div class="dropdown-item" (click)="goToBookings()" *ngIf="!isVisiting">My Booking</div>

            <div class="dropdown-item" (click)="goToProfile()">Profile</div>

            <div class="dropdown-item" (click)="openReferVendorDialog()">Refer Vendors</div>

            <div class="dropdown-item switch-role-item" (click)="openServiceOfferDialog()"
              *ngIf="isVisiting && !isFormPage">
              Register as Vendor
            </div>
          </div>

          <div class="dropdown-divider thin"></div>

          <div class="dropdown-section no-padding">
            <div class="dropdown-item logout" (click)="logout()">Sign Out</div>
          </div>
        </div>
      </div>


    </ng-container>
  </div>
</header>

<!-- MAIN ROUTER CONTENT -->
<router-outlet></router-outlet>

<!-- FOOTER -->
<footer class="footer">
  <div class="footer-container">
    <div class="footer-col">
      <h2>Aluguloo</h2>
      <div class="footer-links-grid">
        <div class="links-column">
          <a href="https://aboutus-3beb1.firebaseapp.com" target="_blank" rel="noopener noreferrer">About us</a>
          <a routerLink="/help-center" target="_blank">Help Center</a>
          <a routerLink="/rental-responsibility" target="_blank">Rental Responsibility</a>
        </div>
        <div class="links-column">
          <a routerLink="/privacy" target="_blank">Privacy</a>
          <a routerLink="/terms" target="_blank">Terms</a>
          <a routerLink="/company-details" target="_blank">Company Details</a>
        </div>
      </div>
    </div>

    <div class="footer-col empty"></div>
  </div>

  <div class="footer-bottom">
    <div class="footer-bottom-left">
      <span class="copyright">© 2026 Aluguloo</span>
      <span class="dot-separator">·</span>
      <span class="powered-by">
        Powered by 
        <a [href]="raiosoftUrl" target="_blank" rel="noopener noreferrer" class="partner-link">Raiosoft</a>. 
        Designed by <span class="partner-text">Onixhu</span>.
      </span>
    </div>

    <div class="footer-bottom-right">
      <span class="version-tag">v{{appVersion}}</span>
    </div>
  </div>
</footer>